import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';
import GradeYearHeader from '../common/GradeYearHeader';
import Spinner from '../../../../components/spinner/Spinner';
import ProgressContent from './ProgressContent';
import './Progress.scss';
import { TITLE } from '../../../../constants/shared/CommonConstants';

const Progress = ({
    student,
    location,
    windowDates,
    isCurrentSchoolYear,
    studentDataByMeasures,
    currentPeriod,
    selectedGradeYear,
    gradeYears,
    isGradeYearsFetching,
    currentSchoolYear,
    LinkWrapper,
    openProbeDetails,
    isHistoricalResultsNotFetched,
    selectGradeYear,
    chartLookerEvent,
    CommonCellBuilder,
    isGoalAvailable,
    probeDetailWrapper,
    isDataMeasureExists,
    getMeasureTitle,
    getSpecificGoal,
    resetZoomLookerEvent,
    toyPeriods,
    summerPeriodLabel,
}) => {
    if (
        isEmpty(selectedGradeYear) ||
        isGradeYearsFetching ||
        !selectedGradeYear.year ||
        isEmpty(studentDataByMeasures)
    ) {
        return <Spinner />;
    }

    const { year } = selectedGradeYear;

    return (
        <>
            <GradeYearHeader
                gradeYears={gradeYears}
                location={location}
                selectGradeYear={selectGradeYear}
                selectedGradeYear={selectedGradeYear}
                LinkWrapper={LinkWrapper}
            />
            {probeDetailWrapper}
            {isHistoricalResultsNotFetched(year) ? (
                <Spinner />
            ) : (
                <ProgressContent
                    student={student}
                    location={location}
                    isCurrentSchoolYear={isCurrentSchoolYear}
                    studentDataByMeasures={studentDataByMeasures}
                    currentPeriod={currentPeriod}
                    windowDates={windowDates}
                    openProbeDetails={openProbeDetails}
                    chartLookerEvent={chartLookerEvent}
                    selectedYear={year}
                    currentSchoolYear={currentSchoolYear}
                    getMeasureTitle={getMeasureTitle}
                    isDataMeasureExists={isDataMeasureExists}
                    CommonCellBuilder={CommonCellBuilder}
                    isGoalAvailable={isGoalAvailable}
                    getSpecificGoal={getSpecificGoal}
                    resetZoomLookerEvent={resetZoomLookerEvent}
                    toyPeriods={toyPeriods}
                    summerPeriodLabel={summerPeriodLabel}
                />
            )}
        </>
    );
};

Progress.defaultProps = {
    student: {},
    isCurrentSchoolYear: true,
    studentDataByMeasures: {},
    currentPeriod: '',
    windowDates: {},
    location: {},
    selectedGradeYear: {},
    gradeYears: [],
    isGradeYearsFetching: false,
    currentSchoolYear: null,
    isHistoricalResultsNotFetched: () => false,
    LinkWrapper: () => {},
    selectGradeYear: () => {},
    openProbeDetails: () => {},
    chartLookerEvent: () => {},
    getMeasureTitle: () => {},
    isDataMeasureExists: () => true,
    probeDetailWrapper: <></>,
    CommonCellBuilder: () => {},
    isGoalAvailable: () => <></>,
    getSpecificGoal: () => '',
    resetZoomLookerEvent: () => {},
    toyPeriods: [],
    summerPeriodLabel: TITLE.SUMMER_TITLE,
};

Progress.propTypes = {
    student: PropTypes.object,
    isCurrentSchoolYear: PropTypes.bool,
    studentDataByMeasures: PropTypes.object,
    currentPeriod: PropTypes.string,
    windowDates: PropTypes.object,
    location: PropTypes.object,
    selectedGradeYear: PropTypes.object,
    gradeYears: PropTypes.array,
    isGradeYearsFetching: PropTypes.bool,
    currentSchoolYear: PropTypes.number,
    isHistoricalResultsNotFetched: PropTypes.func,
    LinkWrapper: PropTypes.func,
    selectGradeYear: PropTypes.func,
    openProbeDetails: PropTypes.func,
    chartLookerEvent: PropTypes.func,
    probeDetailWrapper: PropTypes.object,
    isDataMeasureExists: PropTypes.func,
    getMeasureTitle: PropTypes.func,
    CommonCellBuilder: PropTypes.func,
    isGoalAvailable: PropTypes.func,
    getSpecificGoal: PropTypes.func,
    resetZoomLookerEvent: PropTypes.func,
    toyPeriods: PropTypes.array,
    summerPeriodLabel: PropTypes.string,
};

export default Progress;
